/**
 * Returns a CSS style object with a mask-image that fades out at the bottom
 * Used for masonry widget visual content sections
 */
export function getMasonryFadeMask(): React.CSSProperties {
  return {
    maskImage: "linear-gradient(to bottom, black 0%, transparent 95%)",
    WebkitMaskImage: "linear-gradient(to bottom, black 0%, transparent 95%)",
  }
}

/**
 * Style object for fading content at bottom and right edges
 * Spread into existing style props: style={{ ...FADE_MASK_STYLE, ...otherStyles }}
 */
export const FADE_MASK_STYLE: React.CSSProperties = {
  maskImage:
    "linear-gradient(to bottom, black, transparent), radial-gradient(circle at top left, black 70%, rgba(0,0,0,0.8))",
  WebkitMaskImage:
    "linear-gradient(to bottom, black, transparent), radial-gradient(circle at top left, black 70%, rgba(0,0,0,0.8))",
  maskComposite: "intersect",
  WebkitMaskComposite: "source-in",
}
